// 홈 데스크톱 CTA 히어로 스트립 — 시안 C1 `.hero` (신고 371 §8).
// 좌 = 신청 CTA(클릭 → /main/s/request), 우 = KPI 3칸 인라인(각 칸 클릭 → 그룹 필터).
// KPI 가 CTA 버튼 안에 들어가면 버튼 중첩이 된다 — 래퍼는 div, 클릭 대상만 button 이다.
import React from 'react';
import { T, R, tint } from '../../../theme';
import { useT } from '../../../../i18n/I18nProvider';
import LtrText from '../../parts/LtrText';
import { Glyph } from './Thumb';

var wrap = {
  display: 'flex', alignItems: 'center', gap: 18, padding: '16px 20px', borderRadius: R.lg, minWidth: 0,
  color: T.card, background: 'linear-gradient(135deg,' + T.navy + ',' + T.accent + ')'
};
var cta = {
  display: 'flex', alignItems: 'center', gap: 16, flex: '1 1 auto', minWidth: 0, border: 0, background: 'none',
  padding: 0, color: 'inherit', cursor: 'pointer', fontFamily: 'inherit', textAlign: 'start'
};
var iconBox = { width: 44, height: 44, borderRadius: R.lg, background: 'rgba(255,255,255,.18)', display: 'grid', placeItems: 'center', flex: 'none' };
var txWrap = { minWidth: 0, flex: '1 1 auto' };
var txTitle = { fontSize: 17, fontWeight: 800, letterSpacing: '-.35px' };
var txDesc = { fontSize: 12.5, opacity: .86, marginTop: 2 };
var txHint = { fontSize: 11.5, opacity: .72, marginTop: 3 };
var go = { width: 38, height: 38, borderRadius: R.pill, background: 'rgba(255,255,255,.16)', display: 'grid', placeItems: 'center', flex: 'none' };

var kpiWrap = { display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 10, flex: 'none', width: '38%', maxWidth: 430, minWidth: 0,
  alignItems: 'stretch' };   // 라벨이 2줄이 돼도 타일 3개 높이는 같게 (D6)
var kpi = {
  background: 'rgba(255,255,255,.12)', border: '1px solid rgba(255,255,255,.16)', borderRadius: R.card,
  padding: '8px 12px', minWidth: 0, cursor: 'pointer', fontFamily: 'inherit', color: 'inherit', textAlign: 'start'
};
var kpiHot = Object.assign({}, kpi, { background: tint(T.warnBd, .2), border: '1px solid ' + tint(T.warnBd, .55) });
var kpiNum = { display: 'block', fontSize: 24, fontWeight: 800, letterSpacing: '-.7px', lineHeight: 1.1 };
// 1024 ar 라벨('بانتظار قرارك')은 한 줄에 안 들어간다 — 자르지 말고 2줄로 흘린다 (D6).
var kpiLabel = { display: 'block', fontSize: 11.5, fontWeight: 700, opacity: .85, whiteSpace: 'normal', lineHeight: 1.3 };

/// props: { counts, onNew, onGroup(group) }
function HeroStrip(props) {
  var t = useT();
  var counts = props.counts || {};
  var onGroup = props.onGroup;
  var cells = [
    ['inProgress', t('simpleGroupInProgress'), counts.inProgress || 0, false],
    ['actionNeeded', t('simpleGroupActionNeeded'), counts.actionNeeded || 0, (counts.actionNeeded || 0) > 0],
    ['finished', t('simpleGroupFinished'), counts.finished || 0, false]
  ];
  return (<div className="ss-hero" style={wrap}>
    <button type="button" data-action="new" style={cta} onClick={props.onNew}>
      <span style={iconBox}><Glyph name="car" size={24} /></span>
      <span style={txWrap}>
        <span style={Object.assign({ display: 'block' }, txTitle)}>{t('simpleB1CtaTitleAction')}</span>
        <span style={Object.assign({ display: 'block' }, txDesc)}>{t('simpleB1CtaDesc')}</span>
        <span style={Object.assign({ display: 'block' }, txHint)}>{t('simpleB1CtaShort')}</span>
      </span>
      <span style={go}>
        <svg className="ss-flipx" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
          <path d="M9.5 5.5l6.5 6.5-6.5 6.5" />
        </svg>
      </span>
    </button>
    <div style={kpiWrap}>
      {cells.map(function (c) {
        return (<button key={c[0]} type="button" className="ss-hkpi" data-group={c[0]} style={c[3] ? kpiHot : kpi}
          onClick={function () { onGroup(c[0]); }}>
          <LtrText style={kpiNum}>{c[2]}</LtrText>
          <span style={kpiLabel}>{c[1]}</span>
        </button>);
      })}
    </div>
  </div>);
}

export default HeroStrip;
